import {
  GET_WORKFLOW_MARKETPLACE_WORKFLOWS,
  GET_WORKFLOW_MARKETPLACE_WORKFLOW_IMAGES,
} from '../../state/actionTypes';

const initialState = {
  workflows: [],
  workflowImageMap: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKFLOW_MARKETPLACE_WORKFLOWS: {
      const workflows = Array.isArray(action.payload) ? action.payload : [];
      return { ...state, workflows };
    }
    case GET_WORKFLOW_MARKETPLACE_WORKFLOW_IMAGES: {
      const { name, images } = action.payload;
      return {
        ...state,
        workflowImageMap: {
          ...state.workflowImageMap,
          [name]: images,
        },
      };
    }
    default:
      return state;
  }
};
